import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import { motion, AnimatePresence } from "framer-motion";

const Settings = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { pathname } = useLocation();

  const handleMouseEnter = () => {
    setIsExpanded(true);
  };

  const handleMouseLeave = () => {
    setIsExpanded(false);
  };

  const itemLinkClass =
    "flex gap-x-2 items-center text-md min-h-[42px] py-3 h-auto text-black/70 no-underline pl-3 clear-both whitespace-nowrap customHover";
  const activeItemLinkClass =
    "flex gap-x-2 items-center text-md min-h-[42px] py-3 h-auto text-blue-800 bg-blue-50 rounded-md no-underline pl-3 clear-both whitespace-nowrap customHover";
  const menuIconClass =
    " inline-flex justify-center items-center w-10 h-10 rounded-md leading-34  text-center top-0 relative z-10 text-xl text-gray-600 bg-gray-100 font-semibold";
  const activeMenuIconClass =
    " inline-flex justify-center items-center w-10 h-10 rounded-md leading-34  text-center top-0 relative z-10 text-xl text-blue-800 bg-white font-semibold";

  return (
    <AnimatePresence>
      <motion.div
        className={`side-nav side-nav-light side-nav-expand transition-width duration-600 bg-white shadow-md shadow-gray-200 fixed left-[65px] top-0 pt-[75px] h-screen z-30`}
        initial={{ width: "0px" }} // Initial width when the component mounts
        animate={{ width: isExpanded ? "250px" : "64px" }} // Width animation based on isExpanded state
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Sidebar content */}

        <div className="side-nav-content h-[calc(100vh-70px)]">
          <nav className="menu menu-light pt-5">
            <ul>
              {/* Menu items */}
              <li className="overflow-x-hidden relative">
                <Link
                  to="/clinic/ClinicProfile"
                  className={`${
                    pathname === "/clinic/ClinicProfile"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  {/* <i className={`${menuIconClass}`}>
                    <img src={AppointmentsIcon} alt="none" />
                  </i> */}
                  <i
                    className={`${
                      pathname === "/clinic/ClinicProfile"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <AccountCircleIcon />
                  </i>{" "}
                  <motion.span
                    className={`relative z-10 ${isExpanded ? "" : "hidden"}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, width: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    ClinicProfile
                  </motion.span>
                </Link>
              </li>

              <li className="overflow-x-hidden relative">
                <Link
                  to="/clinic/UserProfile"
                  className={`${
                    pathname === "/clinic/UserProfile"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  {/* <i className={`${menuIconClass}`}>
                    <img src={AppointmentsIcon} alt="none" />
                  </i> */}
                  <i
                    className={`${
                      pathname === "/clinic/UserProfile"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <PersonIcon />
                  </i>
                  <motion.span
                    className={`relative z-10 ${isExpanded ? "" : "hidden"}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, width: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    User Profile
                  </motion.span>
                </Link>
              </li>

              <li className=" overflow-x-hidden  relative">
                <Link
                  to="/clinic/service"
                  className={`${
                    pathname === "/clinic/service"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  <i
                    className={`${
                      pathname === "/clinic/service"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <MedicalServicesIcon />
                  </i>

                  <span className={`relative  ${isExpanded ? "" : "hidden"}`}>
                    Services
                  </span>
                </Link>
              </li>

              {/* <li className=" overflow-x-hidden  relative">
                <Link
                  to="/clinic/EMRSettings"
                  className={`${
                    pathname === "/clinic/EMRSettings"
                      ? activeItemLinkClass
                      : itemLinkClass
                  }`}
                >
                  <i
                    className={`${
                      pathname === "/clinic/EMRSettings"
                        ? activeMenuIconClass
                        : menuIconClass
                    }`}
                  >
                    <SettingsIcon />
                  </i>
                  <motion.span
                    className={`relative z-10 ${isExpanded ? "" : "hidden"}`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, width: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    EMR Settings
                  </motion.span>
                </Link>
              </li> */}

              {/* Add more menu items as needed */}
            </ul>
          </nav>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default Settings;
